import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import styles from 'pages/benefits/support/Support.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Benefits/Support/components/SectionHeader'));
const SectionPitch = dynamic(() => import('sections/Benefits/Support/components/SectionPitch'));
const SectionDevisionCards = dynamic(() => import('sections/Benefits/Support/components/SectionDevisionCards'));
const SectionSupportBenefitsCards = dynamic(() => import('sections/Benefits/Support/components/SectionSupportBenefitsCards'));
const SectionFaq = dynamic(() => import('sections/Benefits/Support/components/SectionFaq'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Benefits/Support/components/SectionForm'));

type SupportProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function SupportPage({ pageTitle, formUrl, leadSubtype }: SupportProps) {
  return (
    <div className={cn('support')}>
      <SectionHeader/>
      <SectionPitch/>
      <SectionDevisionCards/>
      <SectionSupportBenefitsCards/>
      <SectionFaq/>
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm 
        pageTitle={pageTitle} 
        formUrl={formUrl} 
        leadSubtype={leadSubtype}
      /> */}
    </div>
  );
}

export const getStaticProps = async () => {
  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component on all Benefits pages as an additional data: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.support.pageTitle,
  //   formUrl: LeadFormParameters.support.formUrl,
  //   leadSubtype: LeadFormParameters.support.leadSubtype,
  // };
  
  return {
    props: {
      title: 'Support Services for DF Alliance Members | DF Alliance',
      description:
        'Experience top-notch customer support with DF Alliance, offering expert assistance for all your logistics & freight forwarding needs, ensuring smooth operations.',
      path: '/benefits/support',
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

SupportPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
